<template>
  <ul :class="classes">
    <slot></slot>
    <t-time-item v-if="pending" :title="pending === true ? '' : pending">
      <t-icon slot="dot" icon="loading" :class="loadingClass" size="20"></t-icon>
    </t-time-item>
  </ul>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
import TTimeItem from './timeline-item.vue'
import TIcon from '../icon/icon.vue'
const PREFIXCLS = `${PREFIX_CLASS}timeline`

export default {
  name: 'TTimeline',
  components: { TTimeItem, TIcon },
  props: {
    pending: {
      type: [Boolean, String],
      default: false
    },
    pendingColor: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'left', 'right', 'cross']
      }
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIXCLS}`,
        {
          [`${PREFIXCLS}-pending`]: this.pending,
          [`${PREFIXCLS}--horizontal`]: this.horizontal,
          [`${PREFIXCLS}--${this.align}`]: this.align
        }
      ]
    },
    loadingClass() {
      return [
        'icon-gradient-success',
        `${PREFIX_CLASS}ani-loop`
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/timeline/timeline.vue